// =================================================================
//  UPDATING RELATED PRODUCTS LIST
// =================================================================
const getRelatedProducts = async (ids) => {
    let relatedProducts = [];

    for await (const productID of ids) {
        // Base64 encode the GID
        let base64Encode = btoa(productID);

        // Setup query headers
        let headers = {
            "X-Shopify-Storefront-Access-Token": "67b5fd875930b339672137b905fcdacd",
        };

        // FIXME: Check why this query does only work with some base64 encoded IDs
        // Setup query body with the GraphQL query
        let body = `query {
            node(id: "${base64Encode}") {
              ... on ProductVariant {
                id
                title
                compareAtPrice{
                    amount
                }
                price{
                    amount
                }        
                image{
                    url
                }
                product{
                    id
                    title
                    handle
                    options{
                        name
                    }
                    featuredImage{
                        url
                    }
                    compareAtPriceRange{
                        maxVariantPrice{
                            amount
                        }
                    }
                    priceRange{
                        maxVariantPrice{
                            amount
                        }
                    }
                    unit: metafield(namespace: "setting", key: "unit"){
                        value
                    }
                    amount: metafield(namespace: "setting", key: "inhoud_pak"){
                        value
                    }
                }
              }
            }
          }`;

        // Send an ajax request to the storefront API to fetch the product with the base64 encoded ID
        let res = await $.ajax({
            type: "POST",
            url: "https://vloerenmarkt-nl.myshopify.com/api/2023-01/graphql.json",
            dataType: "json",
            headers: headers,
            data: body,
            contentType: "application/graphql",
            error: function (data) {
                // Errors
                console.error("Error in Storefront API request");
                console.log(data);
            },
        });

        relatedProducts.push(res.data);
    }

    return relatedProducts;
};

const checkOptionNames = (optionNames, values) => {
    for (let i = 0; i < optionNames.length; i++) {
        for (let j = 0; j < values.length; j++) {
            if (optionNames[i].toLowerCase().includes(values[j].toLowerCase())) {
                return true;
            }
        }
    }
    return false;
};

const updateRelatedProducts = async (variantUrl) => {
    const productOptionValues = ["Type", "Title", "VloerType"];

    const variant = metaData[variantUrl.split("variant=")[1]];

    // Check if there is an existing variant selected
    if (!variant) return;

    // Get the ID's of the related products fromt the metadata
    const relatedProductsIDs = variant.meta.related_products;

    // Stop if there are no related products
    if (!relatedProductsIDs || relatedProductsIDs.lenght == 0) return;

    const products = await getRelatedProducts(relatedProductsIDs);

    // Get the related products list HTML element
    const relatedProductsList = $("#variant-related-products");

    // Clear the related products list
    $(relatedProductsList).empty();

    for (let i = 0; i < 10; i++) {
        let productHTML;

        if (!products[i] || !products[i].node) {
            continue;
        }

        let inhoud_pak = parseFloat(products[i].node.product?.amount ? products[i].node.product.amount.value : 1);
        let unit = products[i].node.product?.unit?.value ?? "stuk";
        let optionNames = products[i].node.product?.options?.map((option) => option.name) ?? [];

        if (checkOptionNames(optionNames, productOptionValues)) {
            let url = `${baseUrl}/products/${products[i].node.product.handle}`;

            if (!products[i].node.product.compareAtPriceRange) continue;

            productHTML = `
            <li class="related-products__list--item">
                <div class="related-product__wrapper">
                    <a href="${url}">
                        <div class="related-product--image">
                            <img src="${products[i].node.product.featuredImage.url}">
                        </div>
                        <div class="related-product--info">
                            <div class="related-product--title">
                                <h3>${products[i].node.product.title}</h3>
                            </div>
                            <div class="related-product--price">
                                <div class="price__compare-at visible">
                                    <span class="money">€${parseFloat(products[i].node.product.compareAtPriceRange.maxVariantPrice.amount).toFixed(2)}</span>
                                </div>
                                <div class="price__current">
                                    <span class="money">€${(parseFloat(products[i].node.product.priceRange.maxVariantPrice.amount) / inhoud_pak).toFixed(2)}</span>
                                    <span class="unit-text">per ${unit}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </li>`;
        } else {
            let variantID = products[i].node.id.split("ProductVariant/")[1];
            let url = `${baseUrl}/products/${products[i].node.product.handle}?variant=${variantID}`;

            if (!products[i].node.compareAtPrice) continue;

            productHTML = `
            <li class="related-products__list--item">
                <div class="related-product__wrapper">
                    <a href="${url}">
                        <div class="related-product--image">
                            <img src="${products[i].node.image.url}">
                        </div>
                        <div class="related-product--info">
                            <div class="related-product--title">
                                <h3>${products[i].node.product.title} | ${products[i].node.title}</h3>
                            </div>
                            <div class="related-product--price">
                                <div class="price__compare-at visible">
                                    <span class="money">€${parseFloat(products[i].node.compareAtPrice.amount).toFixed(2)}</span>
                                </div>
                                <div class="price__current">
                                    <span class="money">€${(parseFloat(products[i].node.price.amount) / inhoud_pak).toFixed(2)}</span>
                                    <span class="unit-text">per ${unit}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </li>`;
        }

        $(relatedProductsList).append(productHTML);
    }
};

// =================================================================
//  EVENT LISTENERS
// =================================================================
$(document.body).on("change", ".options-selection__option-value-input, .options-selection__input-select", (e) => {
    // Workaround for Firefox
    setTimeout(() => {
        updateRelatedProducts(e.target.baseURI);
    }, 1);
});
